var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86881 0.722833L6.75012 2.49727C6.86888 2.74267 7.18765 2.97549 7.45642 3.02583L9.05028 3.2901C10.0691 3.46 10.3066 4.20249 9.57531 4.94498L8.33148 6.19716C8.12521 6.4048 8.00646 6.81381 8.07521 7.10955L8.43148 8.65746C8.71275 9.87817 8.06271 10.3564 6.99389 9.71457L5.50003 8.82106C5.23127 8.65746 4.78124 8.65746 4.51247 8.82106L3.01861 9.71457C1.94979 10.3501 1.29975 9.87817 1.58102 8.65746L1.93729 7.10955C1.99354 6.80751 1.87479 6.39851 1.66852 6.19087L0.424688 4.93869C-0.306612 4.20249 -0.0690961 3.46 0.949723 3.28381L2.54358 3.01953C2.81235 2.97549 3.13112 2.73638 3.24988 2.49098L4.13119 0.716541C4.61247 -0.239893 5.38753 -0.239893 5.86881 0.722833Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDark);
export default __webpack_public_path__ + "static/media/star_dark.ea82d7cef7577a694235f2fdea4e1dee.svg";
export { ForwardRef as ReactComponent };